import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";
import type { FilterItemType } from "@shared/content-types/types";

import { CulturalObjectsPage } from "@/_pages/cultural-objects";
import { getCulturalObjectsPage } from "@/_pages/cultural-objects/api";
import type {
  CulturalObjectsPageType,
  CulturalObjectsPoints,
} from "@/_pages/cultural-objects/model/types";

type PageProps = {
  cms: {
    filters: FilterItemType[];
    list: CulturalObjectsPoints;
    hero: CulturalObjectsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { filters, list, hero },
  } = props;

  return (
    <CulturalObjectsPage filters={filters} content={list.data} hero={hero} />
  );
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getCulturalObjectsPage()),
      };
    },
    { res },
  );
}

export default Page;
